import { VisuallyHidden } from "react-aria";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

import { useCartStore } from "~/stores/use-cart-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import MiscProductForm from "./misc-product-form";

export default function MiscProductDialog() {
  const { miscProductOpen, setMiscProductOpen } = useCartStore(
    useShallow((state) => ({
      miscProductOpen: state.miscProductOpen,
      setMiscProductOpen: state.setMiscProductOpen,
    })),
  );

  const { t } = useTranslation("common");
  return (
    <Dialog open={miscProductOpen} onOpenChange={setMiscProductOpen}>
      <DialogContent
        className="max-w-lg w-full"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Product</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <MiscProductForm onClose={() => setMiscProductOpen(false)} />
        </div>
        <DialogFooter>
          <Button
            form="misc-product-form"
            className="w-full"
            type="submit"
            variant="success"
          >
            {t("MiscProduct.add")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
